<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Set Course Plan Week</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <v-autocomplete dense required v-model="ay" :items="ay_list" item-text="ay" item-value="id"
              label="Academic Year" outlined rounded persistent-hint hint="Please Select Academic Year"
              multiple></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete dense required v-model="course" :items="course_list" item-text="name" item-value="id"
              label="Course/Subject" outlined rounded persistent-hint
              hint="Please Select Course/Subject"></v-autocomplete>
          </v-col>
        </v-row>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <!-- <p><b>From Date</b></p> -->
            <v-text-field outlined dense type="date" v-model="fromdate" label="From Date"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <!-- <p><b>To Date</b></p> -->
            <v-text-field outlined dense type="date" v-model="todate" label="To Date"></v-text-field>
          </v-col>
        </v-row>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <!-- <p><b>From Date</b></p> -->
            <v-text-field outlined dense type="number" v-model="week_no" label="Week Number"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <!-- <p><b>From     Date</b></p> -->
            <v-textarea label="Description" outlined rounded v-model="description" dense placeholder="Description"
              hint="Description"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="ay && course && fromdate && todate && week_no">
          <v-btn @click="saveCoursePlanWeek()" :loading="loader" color="info">save</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="course_plan_week_list!=''">
        <v-data-table :headers="headers" :items="course_plan_week_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Course Plan Week List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </v-card>
      <v-row justify="center">
        <v-dialog v-model="edit_dialog" max-width="900px">
          <v-card>
            <v-toolbar class="toolbar">
              <v-btn icon dark @click="edit_dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Edit Course Plan Week</v-toolbar-title>
              <v-toolbar-items>
                <v-btn dark text @click="edit_dialog = false">Close</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <br>
            <v-row justify="center" dense>
              <v-col cols="12" sm="5" md="5">
                <v-text-field outlined dense type="date" v-model="editedItem.fromdate" label="From Date"></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <v-text-field outlined dense type="date" v-model="editedItem.todate" label="To Date"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="6">
                <v-textarea outlined name="input-7-4" v-model="editedItem.description" label="Description"></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-btn @click="saveUpdateCoursePlanWeek()" :loading="loader" color="info">Update</v-btn>
            </v-row>
          </v-card>
        </v-dialog>
      </v-row>

    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      week_no:"",edit_dialog:false,
      fromdate: new Date().toISOString().slice(0, 10),
      todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
      loader:false,
      snackbar_msg: "",
      color: "",
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      snackbar: false,
      overlay: false,
      description:"",
      headers:[
      { text: "Week No", value: "weekno" },
      { text: "Description", value: "description" },
      { text: "Academic Year", value: "academicyear" },
      { text: "From Date", value: "from_date" },
      { text: "To Date", value: "to_date" },
      { text: "Course", value: "course" },
      { text: "Entered By", value: "enteredby" },
      { text: "Edit", value: "edit" },
      ],
      course_plan_week_list:[],ay:[],course_list:[],course:"",ay:"",
      editedItem: {
        id: "",
        name: "",
        description: "",
        from_date: "",
        to_date: "",
    },
  }),
   methods: {
    editItem(item){
      this.editedItem.id=item.id
      this.editedItem.description=item.description
      this.editedItem.fromdate=item.from_date_edit
      this.editedItem.todate=item.to_date_edit
      this.edit_dialog=true
    },
     async toggleisactive(item) {
      const formData = {
                    planner_id: item.id,
                    isactive: item.isactive,
                };
      try {
          const res = await axios.post("/LessonPlanning/toggleCoursePlanner",formData);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Updated Successfully..."); // show snackbar
            this.course_planner_list=res.data.course_planner_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
        this.course='',this.instructor=[]
      }
     
    },
     async saveUpdateCoursePlanWeek() {
      try {
          const res = await axios.post("/LessonPlanning/saveUpdateCoursePlanWeek",this.editedItem);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Updated Successfully..."); // show snackbar
              this.course_plan_week_list=res.data.course_plan_week_list
              this.edit_dialog=false
          }else if(res.data.flag == "No"){
             this.showSnackbar("red", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
        this.course='',this.description=""
        this.edit_dialog=false
      }
     
    },
     async saveCoursePlanWeek() {
      const formData = {
                    course: this.course,
                    ay: this.ay,
                    fromdate: this.fromdate,
                    todate: this.todate,
                    week_no: this.week_no,
                    description: this.description,
                };
      try {
          const res = await axios.post("/LessonPlanning/saveCoursePlanWeek",formData);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Added Successfully..."); // show snackbar
            this.course_plan_week_list=res.data.course_plan_week_list
          }else if(res.data.flag == "No"){
             this.showSnackbar("red", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
        this.course='',this.description=""
      }
     
    },
    async onLoad() {
      try {
          const res = await axios.post("/LessonPlanning/getCoursePlanWeekList");
          if (res.data.flag == "YES") {
            this.ay_list=res.data.ay_list,
            this.ay=res.data.cay
            this.course_list=res.data.course_list
            this.course_plan_week_list=res.data.course_plan_week_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>